export class FuncionarioModel {
    cod_funcionario?: number
    apelido?: string
    nome?: string
    endereco_tecnico?: string
    bairro_tecnico?: string
    longitude?: string
    latitude?: string
    endereco_imagem?: string
    data_localizacao?: string
    hora_localizacao?: string
    tipo?: string
    endereco_imagem_tecnico?: string
    endereco_imagem_ass_email?: string
    departamento?: string
    ativo?: string
    tecnico_logado?: boolean


    longitude_web?:number
    latitude_web?:number

    //USADO EM TEMPO REAL
    filtro_data_inicial?: Date
    filtro_data_final?: Date
}